import { HttpClient, HttpUrlEncodingCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ListServices, PageControl } from 'app/shared/objects/main';
import { CitiesInfo, CitiesInfoBasic, CityDataSource, CityDataInfo, CityProfileHistory, IndicatorSearchFilter } from 'app/shared/objects/cities';
import { Observable } from 'rxjs';
import { Certification } from 'app/shared/objects/certification';

@Injectable()
export class PainelCitiesService {

  constructor(private http: HttpClient) {}

  getCities(params: CitiesPainelSearch): Promise<ListServices> {
    return this.http.post(environment.apiURL + '/admin/city/search', params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  getFilterCountryContinent(): Promise<string[]> {
    return this.http.get(environment.apiURL + '/frontEndOpen/getRegionFilters')
        .toPromise()
        .then(response => {
            return response;
        })
        .catch(error => {
          return null;
        });
  }

  getCitiesCompleteness(): Promise<PainelCompletenessStats> {
    return this.http.get(environment.apiURL + '/admin/city/completenessStats')
        .toPromise()
        .then(response => {
            return response;
        })
        .catch(error => {
          return null;
        });
  }

  getCity(id: string): Promise<CitiesInfo> {
    return this.http.get(environment.apiURL + '/admin/city/load/' + id)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  saveBasicInfo(params: CitiesInfoBasic): Promise<CitiesInfo> {
    return this.http.post(environment.apiURL + '/admin/city/saveBasicInfo', params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  getCountries(): Promise<any> {
    return this.http.get(environment.apiURL + '/frontEndOpen/getRegionFilters')
        .toPromise()
        .then(response => {
            return response;
        })
        .catch(error => {
          return null;
        });
  }

  getGeocode(address: string): Promise<any> {
    return this.http.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + encodeURI(address) + '&key=' + environment.mapsKey)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  getDataSources(): Promise<CityDataSource[]> {
    return this.http.get(environment.apiURL + '/admin/city/dataSources')
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  getCertifications(): Observable<Certification[]> {
    return this.http.get<Certification[]>(`${environment.apiURL}/admin/certifications`);
  }

  insertDataSources(params): Promise<any> {
    return this.http.put(environment.apiURL + '/admin/city/dataSource', params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  saveProfileFullYear(params, cityId: string, year: string): Promise<CitiesInfo> {
    return this.http.post(environment.apiURL + '/admin/city/saveProfileFullYear/' + cityId + '/' + year, params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  saveProfileSingleItem(params, cityId: string, year: string): Promise<CitiesInfo> {
    return this.http.post(environment.apiURL + '/admin/city/saveProfileSingleItem/' + cityId + '/' + year, params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  // Solutions
  addCitySolution(cityId: string, solutionId: string): Promise<any> {
    return this.http.put(environment.apiURL + '/admin/city/solution/' + cityId + '/' + solutionId, {})
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  removeCitySolution(cityId: string, solutionId: string): Promise<any> {
    return this.http.delete(environment.apiURL + '/admin/city/solution/' + cityId + '/' + solutionId, {})
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  getCitySolutions(cityId: string): Promise<any> {
    return this.http.get(environment.apiURL + '/admin/city/solutionsInfo/' + cityId)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  // Indicators
  getIndicatorHistory(cityId: string, data: IndicatorSearchFilter): Promise < any > {
    return this.http.post(environment.apiURL + '/admin/city/indicatorHistory/' + cityId, data)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  saveIndicatorsFullYear(params, cityId: string, year: string): Promise<CitiesInfo> {
    return this.http.post(environment.apiURL + '/admin/city/saveIndicatorsFullYear/' + cityId + '/' + year, params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  saveIndicatorSingleItem(params, cityId: string, year: string): Promise<CitiesInfo> {
    return this.http.post(environment.apiURL + '/admin/city/saveIndicatorSingleItem/' + cityId + '/' + year, params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }
}

export class CitiesPainelSearch {
  completenessRange: MinMax = new MinMax;
  searchQuery: string;
  countryContinent: string[] = [];
  pageControl: PageControl = new PageControl;
  populationRanges: MinMax[] = [];
  topAreas: string[] = [];
}

class MinMax {
  max: number;
  min: number;
}

export class PainelCompletenessStats {
  totalCities: number;
  completenessRanges: Array<any>;
}
